import React from 'react';

import {blueColor, greyishBlue500} from 'assets/jss/main';

function LogEntryMarker() {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                alignSelf: 'stretch',
                gap: '2px',
                width: '8px',
            }}
        >
            <div
                style={{
                    width: '8px',
                    height: '8px',
                    flexShrink: 0,
                    borderRadius: '50%',
                    backgroundColor: blueColor,
                }}
            />

            <div
                style={{
                    flex: '1 0 0',
                    width: '1px',
                    backgroundColor: greyishBlue500,
                }}
            />
        </div>
    );
}

export default LogEntryMarker;
